import StickyScrollBar from "~/stickyScrollBar"

/**
 * requires the element this directive is placed on has an id
 */
export default {
    inserted: (el, binding, vnode) => {
      el.stickyScrollBar = new StickyScrollBar(el.id, binding.value)
      el.stickyScrollBar.init()
      el.classList.add('scrollbar-hidden')
    },
    unbind: (el, binding, vnode) => {
      el.stickyScrollBar?.destroy()
      el.classList.remove('scrollbar-hidden')
    }
}